import { AppConfig } from '../interfaces/AppConfig';

export default {
    frontendBase: 'https://member.intelingu.com',
    backendBase: 'https://backend.intelingu.com',
    apiUrl: 'https://backend.intelingu.com/ig_frontend_api',
    apiKey: 'KTmeIFoEuOZZcJqtm6fElU4Cs0iSJiTThkmpkUFGk5ShU156jdcmG0n54DP2bqzA',
    audioUploadPrefix: 'https://backend.intelingu.com/wp-content/uploads/audio/audio_file_',
    sentry: 'https://5e285a3292ba4868903b19345887b374@sentry.mhm-dev.net/4',
    sentryApp: 'https://0b586501896f455aab2daa76738147c1@sentry.mhm-dev.net/7',
    connectionTimeout: 10000,
    milestoneCards: 500,
} as AppConfig;
